<template>
    <section class="hero page" v-if="data" :class="['type-' + heroType, { 'contains-no-bg': !headerImage }]"
        :data-hero-size="heroSize">
        <div class="bg-vid-wrapper">
            <div class="bg-vid-inner-container" v-if="shortAssetData && videoStarted">
                <!-- <div
					:id="'hero-' + shortAssetData.mediaId"
					style="position: absolute; width: 100%; height: 100%"
				></div> -->
                <div class="short-vid-wrapper">
                    <video autoplay muted playsinline loop>
                        <source :src="videoShortUrl" type="video/mp4" />
                    </video>
                </div>
            </div>
            <transition name="vid-fade">
                <div class="thumbnail" v-if="!videoStarted && headerImage">
                    <div class="bg-wrapper" v-if="headerImage.url" v-bind:style="{
                        'background-image': 'url(' + headerImage.url + ')',
                    }
                        "></div>
                </div>
            </transition>
        </div>
        <div class="container">
            <div class="column-wrapper">
                <div class="column content">
                    <span class="header-subtitle" v-if="data.headerSubtitle && data.headerSubtitle !== ''"
                        v-html="data.headerSubtitle"></span>
                    <h1 class="header-title" v-if="data.headerTitle && data.headerTitle !== ''" v-html="data.headerTitle">
                    </h1>
                    <div class="intro" v-if="data.headerIntroText &&
                        data.headerIntroText !== '<p><br></p>'
                        " v-html="data.headerIntroText"></div>
                    <ul class="button-wrapper" v-if="buttonData && buttonData.length > 0">
                        <li v-for=" buttonItem  in  buttonData " :key="buttonItem.slug">
                            <router-link class="button" :data-txt="buttonItem.label" :to="buttonItem.slug">{{
                                buttonItem.label }}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {
    fetchCmsMedia,
    fetchVideoContentDetails,
} from "@streampac.io/chef_sp_1";

export default {
    data() {
        return {
            shortAssetData: null,
            headerImage: null,
            videoStarted: false,
            buttonData: [],
            videoShortUrl: null,
        };
    },
    inject: ["isAuthenticated"],
    props: ["data", "heroType", "heroSize", "vixyFlavorId"],
    components: {},
    created() {
        if (this.data) {
            //console.log(this.data);
            if (this.data && this.data.headerImage !== "") {
                this.headerImage = this.data.headerImageModel;
            }

            if (
                this.data &&
                this.data.headerHighlightVideo !== "" &&
                this.data.headerHighlightVideo !== undefined
            ) {
                fetchVideoContentDetails(
                    this.isAuthenticated,
                    this.data.headerHighlightVideo,
                    "?flattenFields=true"
                ).then((response) => {
                    this.shortAssetData = response;

                    setTimeout(() => {
                        this.initPlayer();
                    }, 300);
                });
            }

            let buttonArray = [];

            if (this.data.headerButtonUrl && this.data.headerButtonUrl !== "") {
                let buttonLabel = "Read more";

                if (
                    this.data.headerButtonLabel &&
                    this.data.headerButtonLabel !== ""
                ) {
                    buttonLabel = this.data.headerButtonLabel;
                }

                const buttonItem = {
                    slug: "/" + this.data.headerButtonUrl,
                    label: buttonLabel,
                };

                buttonArray.push(buttonItem);
            }

            if (
                this.data.headerSecondButtonUrl &&
                this.data.headerSecondButtonUrl !== ""
            ) {
                let buttonLabel = "Read more";

                if (
                    this.data.headerSecondButtonLabel &&
                    this.data.headerSecondButtonLabel !== ""
                ) {
                    buttonLabel = this.data.headerSecondButtonLabel;
                }

                const buttonItem = {
                    slug: "/" + this.data.headerSecondButtonUrl,
                    label: buttonLabel,
                };

                buttonArray.push(buttonItem);
            }

            this.buttonData = buttonArray;
        }
    },
    methods: {
        resolveCmsMedia(val, name) {
            if (val !== "") {
                fetchCmsMedia(this.isAuthenticated, val).then((response) => {
                    this[name] = response;
                });
            }
        },
        stripHtml(val) {
            const strippedString = val.replace(/(<([^>]+)>)/gi, "");

            return strippedString;
        },
        initPlayer() {
            if (this.shortAssetData) {
                const vixyPartnerId = this.$store.state.getVixyParams.partner;
                const vidMediaId = this.shortAssetData.mediaId;
                let flavorId = "0_6czb2u7c";

                if (this.vixyFlavorId && this.vixyFlavorId !== "") {
                    flavorId = this.vixyFlavorId;
                }

                if (vidMediaId && vidMediaId !== "") {
                    this.videoShortUrl =
                        "https://platform.vixyvideo.com/p/" +
                        vixyPartnerId +
                        "/sp/" +
                        vixyPartnerId +
                        "00/playManifest/entryId/" +
                        vidMediaId +
                        "/flavorId/" +
                        flavorId +
                        "/format/url/protocol/https/a.mp4";

                    this.videoStarted = true;
                }
            }
        },
        formatDate() {
            let initialDate = this.data.publicationDate;

            const months = [
                "Jan.",
                "Feb.",
                "Mrt.",
                "Apr.",
                "Mei.",
                "Jun.",
                "Jul.",
                "Aug.",
                "Sept.",
                "Okt.",
                "Nov.",
                "Dec.",
            ];

            let d = new Date(initialDate);

            const monthIndex = d.getMonth();
            const monthName = months[monthIndex];
            const year = d.getFullYear();
            const day = d.getDate();

            return day + " " + monthName + " " + year;
        },
    },
};
</script>

<style lang="scss" scoped>
// @import styles
@import "./index.scss";
</style>

<style lang="scss">
@media only screen and (max-width: 1500px) {
    .hero.page .kWidgetIframeContainer {
        transform: scale(1.3);
    }
}

@media only screen and (max-width: 1180px) {
    .hero.page .kWidgetIframeContainer {
        transform: scale(1.5);
    }
}

@media only screen and (max-width: 980px) {
    .hero.page .kWidgetIframeContainer {
        transform: none;
    }
}

@media only screen and (max-width: 600px) {
    .hero.page .kWidgetIframeContainer {
        transform: scale(1.4);
    }
}
</style>
